module.exports = __webpack_public_path__ + "static/media/r124.8aed7f51.jpg";